module.exports = __webpack_public_path__ + "static/media/acessibility.dba73fd8.svg";